/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'ai-mate.chat-error-banner.description': '您的聊天記錄最多可儲存 30 天。',
  'ai-mate.chat-error-banner.title': '開始新聊天',
  'ai-mate.chat-error.description': '嘗試<btn>重新載入聊天</btn>。',
  'ai-mate.chat-error.rate-limited-description': '您已達到要求的數量上限。請稍後再試一次。',
  'ai-mate.chat-error.rate-limited-title': '要求過多',
  'ai-mate.chat-error.rovo-inactive-description': '您的網站似乎並未啟用 Rovo。<link>設定 Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo 處於非作用中的狀態',
  'ai-mate.chat-error.title': '我們不確定發生了什麼問題',
  'conversation-assistant-button.label': '聊天',
  'conversation-assistant-button.rovo-chat-label': 'Rovo Chat',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': '向 AI 詢問',
  'highlight-actions.rovo-chat-explain-option.text': '說明',
  'highlight-actions.rovo-chat-explain-prompt': '說明這個：{selectedText}',
  'highlight-actions.rovo-chat-more-options.tooltip': '聊天建議',
  'highlight-actions.rovo-chat-open-chat.tooltip': '開啟聊天',
  'highlight-actions.rovo-chat-summarize-option.text': '總結',
  'highlight-actions.rovo-chat-summarize-prompt': '摘要這個：{selectedText}',
  'highlight-actions.rovo-chat.button-text': '聊天',
  'horizontal-scroll-container.scroll-left': '向左捲動',
  'horizontal-scroll-container.scroll-right': '向右捲動',
};
